"use client";
import { RefreshCw } from "lucide-react";
import { Alert } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";

interface StripeInitErrorProps {
  message: string;
  onRetry: VoidFunction;
}

export function StripeInitError({ message, onRetry }: StripeInitErrorProps) {
  return (
    <div className="flex flex-col gap-5">
      <Alert variant="error" message={message} />
      <Button onClick={onRetry} color="secondary" icon={RefreshCw}>
        Try Again
      </Button>
    </div>
  );
}
